
export function mapsBoundsScale(bounds: google.maps.LatLngBounds, scaleFactor: number) : google.maps.LatLngBounds {
    const center = bounds.getCenter();
    const result = new google.maps.LatLngBounds();
        result.extend({
            lat: (bounds.getNorthEast().lat() - center.lat()) * scaleFactor + center.lat(),
            lng: (bounds.getNorthEast().lng() - center.lng()) * scaleFactor + center.lng()
        });
        result.extend({
            lat: (bounds.getSouthWest().lat() - center.lat()) * scaleFactor + center.lat(),
            lng: (bounds.getSouthWest().lng() - center.lng()) * scaleFactor + center.lng()
        });
    return result;
}
